import { render, staticRenderFns } from "./land.vue?vue&type=template&id=0f9fe556&scoped=true&"
import script from "./land.vue?vue&type=script&lang=js&"
export * from "./land.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9fe556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f9fe556')) {
      api.createRecord('0f9fe556', component.options)
    } else {
      api.reload('0f9fe556', component.options)
    }
    module.hot.accept("./land.vue?vue&type=template&id=0f9fe556&scoped=true&", function () {
      api.rerender('0f9fe556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/land/land.vue"
export default component.exports